import { render, staticRenderFns } from "./Recycle.vue?vue&type=template&id=642782bb&scoped=true"
import script from "./Recycle.vue?vue&type=script&lang=js"
export * from "./Recycle.vue?vue&type=script&lang=js"
import style0 from "./Recycle.vue?vue&type=style&index=0&id=642782bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642782bb",
  null
  
)

export default component.exports